import { render, staticRenderFns } from "./HeadReport.vue?vue&type=template&id=570226c8&scoped=true&"
import script from "./HeadReport.vue?vue&type=script&lang=ts&"
export * from "./HeadReport.vue?vue&type=script&lang=ts&"
import style0 from "./HeadReport.vue?vue&type=style&index=0&id=570226c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570226c8",
  null
  
)

export default component.exports